import { customTV } from '../../utils/tailwind';
export const drawer = customTV({
    base: 'dark:bg-background-overlay-dark bg-background-overlay animate-slide-in-right fixed inset-y-0 left-auto right-0 flex w-full flex-col',
});
